export const checkPrevAndCurrData = (data,prevData) => {
    let ans=false;
    for(const key in data){
       ans=ans||(data[key]!==prevData[key])
    }
    return ans;
  }